import {
  continentsListDe,
  continentsList,
  mostBookedDestinations,
} from '../../data/countries-list';
import { getStaticCountryData } from '../../data/countriesStaticData';

export const handleSearch = (search, lang = 'en') => {
  const continents = lang === 'de' ? continentsListDe : continentsList;

  // Handle case where search is a function or not a string
  if (typeof search !== 'string') {
    search = '';
  }

  // Helper function to add static data to country objects
  const addStaticDataToCountry = country => {
    const staticData = getStaticCountryData(country.nameEn);
    const displayName = lang === 'de' ? country.nameDe : country.nameEn;
    
    if (staticData) {
      return {
        ...country,
        name: displayName,
        predictionPlace: {
          address: displayName,
          bounds: staticData.bounds,
          origin: staticData.origin,
          country: staticData.countryCode,
        },
      };
    }
    
    return {
      ...country,
      name: displayName,
    };
  };

  if (!search || search.trim() === '') {
    const allCountries = Object.entries(continents).flatMap(([continentKey, continentData]) => {
      return continentData.countries.map(country => {
        const countryWithStatic = addStaticDataToCountry(country);
        return {
          ...countryWithStatic,
          continentKey,
          continentTitle: lang === 'de' ? continentData.titleDe : continentData.titleEn,
          continent: lang === 'de' ? continentData.titleDe : continentData.titleEn,
        };
      });
    });

    const mostBooked = mostBookedDestinations.map(dest => {
      const destWithStatic = addStaticDataToCountry(dest);
      return {
        ...destWithStatic,
        continent: 'Most Popular',
      };
    });

    return [...mostBooked, ...allCountries];
  }

  const searchTerm = search.toLowerCase();

  try {
    const allCountries = Object.entries(continents).flatMap(([continentKey, continentData]) => {
      return continentData.countries.map(country => {
        const countryWithStatic = addStaticDataToCountry(country);
        return {
          ...countryWithStatic,
          continentKey,
          continentTitle: lang === 'de' ? continentData.titleDe : continentData.titleEn,
        };
      });
    });

    const filteredCountries = allCountries
      .filter(country => {
        const countryNameEn = country.nameEn?.toLowerCase() || '';
        const countryNameDe = country.nameDe?.toLowerCase() || '';

        const matches = countryNameEn.includes(searchTerm) || countryNameDe.includes(searchTerm);
        return matches;
      })
      .map(country => ({
        ...country,
        continent: country.continentTitle,
      }))
      .slice(0, 5);

    return filteredCountries;
  } catch (error) {
    console.error('Error in handleSearch:', error);
    return [];
  }
};

export const PlaceIdToCountry = async geocoder => {
  const countries = [''];

  for (const country of countries) {
    const value = await geocoder.getPlaceId(country);
  }
};
